// code to animate elements of the intro screen
// 2 options to do this, 1 use js code with class names and transitions or 2 to use css animations and keyframes
// This is initial file to attept the complete animation using just transitions, classnames and js intervals
// call init() to begin animation

enum IntroAnimAction {
  end = "introAnimEnded",
}

enum Fade {
  in = "show",
  out = "hide",
}
interface AnimationSequence {
  timerDelay: number;
  animationFunction: Function;
}

let gAnimationIndex: number = 0;
let callBack: Function;
let timeoutId: any;

const getClass = (type: string, modifier: string) => {
  return `intro-screen__item-${type} intro-screen__text intro-screen__text--${modifier}`;
};

const transitionTier = (type: string, i: number, modifier: string) => {
  if (type === "Img") {
    const el: HTMLElement = document.getElementById(`tier${i}Img`)!;
    el.className = `tier__img tier__img--${modifier}`;
  } else if (type === "IntroText") {
    const el: HTMLElement | null = document.getElementById(`IntroText${i}`);
    if (el) el.className = getClass("introtext", modifier);
  } else if (type === "Heading") {
    const el: HTMLElement = document.getElementById(`tier${i}Heading`)!;
    el.className = getClass("heading", modifier);
  } else if (type === "Description") {
    const el: HTMLElement = document.getElementById(`tier${i}Description`)!;
    el.className = getClass("description", modifier);
  }
};

// FRAMES 0 - 17 - move all tiers from centre to final position
const startTimeline = (): void =>
  document
    .getElementById("IntroScreenTimeline")
    ?.classList.add("intro-anim__timeline--final");
const IntroTextIn = (): void => transitionTier("IntroText", 1, Fade.in);
const IntroTextOut = (): void => transitionTier("IntroText", 1, Fade.out);
const showTiers = (): void => {
  document
    .getElementById("tiers-container")
    ?.classList.remove("tiers-container--hide");
};
const animateTier1Img = (): void => {
  transitionTier("Img", 1, "selected");
  transitionTier("Img", 2, "deselected");
  transitionTier("Img", 3, "deselected");
};
const animateTiersToFinalPosition = (): void => {
  document.getElementById("tier1")!.className = "tier tier1__pos--final";
  document.getElementById("tier2")!.className = "tier tier2__pos--final";
  document.getElementById("tier3")!.className = "tier tier3__pos--final";
};
const animateTier1Heading = () => transitionTier("Heading", 1, Fade.in);
const animateTier1Description = (): void =>
  transitionTier("Description", 1, Fade.in);
const animateTier2Img = (): void => {
  transitionTier("Img", 1, "deselected");
  transitionTier("Heading", 1, Fade.out);
  transitionTier("Description", 1, Fade.out);
  transitionTier("Img", 2, "selected");
};
const animateTier2Heading = (): void => transitionTier("Heading", 2, Fade.in);
const animateTier2Description = (): void =>
  transitionTier("Description", 2, Fade.in);
const animateTier3Img = (): void => {
  transitionTier("Img", 2, "deselected");
  transitionTier("Heading", 2, Fade.out);
  transitionTier("Description", 2, Fade.out);
  transitionTier("Img", 3, "selected");
};
const animateTier3Heading = (): void => transitionTier("Heading", 3, Fade.in);
const animateTier3Description = (): void =>
  transitionTier("Description", 3, Fade.in);
const animateTier3Out = (): void => {
  transitionTier("Img", 1, "deselected2");
  transitionTier("Img", 2, "deselected2");
  transitionTier("Img", 3, "deselected2");
  transitionTier("Heading", 3, Fade.out);
  transitionTier("Description", 3, Fade.out);
};
const outroTextIn = (): void => {
  const text1: HTMLElement | null = document.getElementById("IntroText1");
  const icon1: HTMLElement | null = document.getElementById("introAnimIcon");
  if (text1) text1.style.display = "none";
  if (icon1) icon1.classList.add("intro-anim__icon1--transition");
  transitionTier("IntroText", 2, Fade.in);
};
const outroTextOut = (): void => transitionTier("IntroText", 2, Fade.out);

const quit = (): void => {
  clearTimeout(timeoutId);
  callBack({ ACTION: IntroAnimAction.end });
};

const callNextAnimation = () => {
  if (gAnimationIndex < AnimationSequences.length) {
    const { timerDelay, animationFunction } = AnimationSequences[
      gAnimationIndex
    ];
    gAnimationIndex++;
    timeoutId = setTimeout(() => {
      animationFunction();
      callNextAnimation();
    }, timerDelay);
  }
};

const AnimationSequences: AnimationSequence[] = [
  { timerDelay: 50, animationFunction: startTimeline },
  { timerDelay: 50, animationFunction: IntroTextIn },
  { timerDelay: 4600, animationFunction: IntroTextOut },
  { timerDelay: 50, animationFunction: showTiers },
  { timerDelay: 100, animationFunction: animateTiersToFinalPosition },
  { timerDelay: 510, animationFunction: animateTier1Img },
  { timerDelay: 400, animationFunction: animateTier1Heading },
  { timerDelay: 1100, animationFunction: animateTier1Description },
  { timerDelay: 5000, animationFunction: animateTier2Img },
  { timerDelay: 400, animationFunction: animateTier2Heading },
  { timerDelay: 1100, animationFunction: animateTier2Description },
  { timerDelay: 5000, animationFunction: animateTier3Img },
  { timerDelay: 400, animationFunction: animateTier3Heading },
  { timerDelay: 1100, animationFunction: animateTier3Description },
  { timerDelay: 5000, animationFunction: animateTier3Out },
  { timerDelay: 500, animationFunction: outroTextIn },
  { timerDelay: 4600, animationFunction: outroTextOut },
  { timerDelay: 700, animationFunction: quit },
];

const init = (introAnimCallback: Function): void => {
  callBack = introAnimCallback;
  callNextAnimation();
};

export { init, quit, IntroAnimAction };
